export class ContactProperty {
  public static ofCollection(data: any[]): ContactProperty[] {
    const result: ContactProperty[] = [];
    for (const record of data) {
      result.push(new ContactProperty(record));
    }

    return result;
  }

  public propertyId: string;
  public displayName: string;
  public isActive: boolean;
  public order: number;
  public description?: string;
  public example?: string;
  public icon?: string;
  public fixed: boolean;
  public origin: string;

  public constructor(data?: any) {
    this.propertyId = (data && data.PropertyId) ? data.PropertyId : null;
    this.displayName = (data && data.DisplayName) ? data.DisplayName : null;
    this.isActive = (data && data.IsActive) ? data.IsActive : true;
    this.order = (data && data.Order) ? data.Order : 0;
    this.description = (data && data.Description) ? data.Description : null;
    this.example = (data && data.Example) ? data.Example : null;
    this.icon = (data && data.icon) ? data.icon : 'el-icon-price-tag';
    this.fixed = (data && data.PropertyId && (data.PropertyId === 'cname')) ? true : false;
    this.origin = (data && data.Origin) ? data.Origin : null;
  }
}
